import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaBars, FaTimes, FaCaretDown } from "react-icons/fa";

const MENU = [
	{ text: "Home", to: "/" },
	{
		text: "About Us",
		to: "/about",
		sub: [
			{ label: "Our Profile", url: "/profile" },
			{ label: "Vision", url: "/vision" },
			{ label: "Mission", url: "/mission" },
			{ label: "Objective", url: "/objective" },
			{ label: "Board Members", url: "/boardmembers" },
		],
	},
	{
		text: "Services",
		to: "/services",
		sub: [
			{ label: "Deposit", url: "/deposit" },
			{ label: "Loan", url: "/loan" },
			{ label: "Remittance", url: "/remittance" },
			{ label: "Mobile Banking", url: "/mobilebanking" },
			{ label: "SMS Banking", url: "/smsbanking" },
		],
	},
	{ text: "Notices", to: "/notices" },
	{ text: "News & Events", to: "/events" },
	{ text: "Reports", to: "/reports" },
];

const Navbar = () => {
	const [open, setOpen] = useState(false);
	const [openItem, setOpenItem] = useState(null);
	const [downloads, setDownloads] = useState([]);
	const location = useLocation();

	useEffect(() => {
		fetch("/api/downloadfile/")
			.then((res) => res.json())
			.then((data) => {
				if (Array.isArray(data)) setDownloads(data);
			})
			.catch((error) => console.log(error));
	}, []);

	// Close the menu after moving to another page
	useEffect(() => {
		setOpen(false);
		setOpenItem(null);
	}, [location.pathname]);

	const isActive = (to) =>
		to === "/" ? location.pathname === "/" : location.pathname.startsWith(to);

	const toggleItem = (text) => setOpenItem(openItem === text ? null : text);

	const withSub = (item, key, links) => (
		<li
			key={key}
			className={openItem === key ? "nv-item is-open" : "nv-item"}
		>
			<button
				type='button'
				className={isActive(item.to || "/none") ? "nv-link is-active" : "nv-link"}
				onClick={() => toggleItem(key)}
				aria-expanded={openItem === key}
			>
				{item.text} <FaCaretDown />
			</button>
			<ul className='nv-sub'>{links}</ul>
		</li>
	);

	return (
		<nav className='nv' aria-label='Main menu'>
			<div className='container'>
				<button
					type='button'
					className='nv-toggle'
					onClick={() => setOpen(!open)}
					aria-label={open ? "Close menu" : "Open menu"}
				>
					{open ? <FaTimes /> : <FaBars />}
				</button>
				<ul className={open ? "nv-list is-open" : "nv-list"}>
					{MENU.map((item) =>
						item.sub ? (
							withSub(
								item,
								item.text,
								item.sub.map((s) => (
									<li key={s.url}>
										<Link to={s.url}>{s.label}</Link>
									</li>
								))
							)
						) : (
							<li key={item.text} className='nv-item'>
								<Link
									to={item.to}
									className={isActive(item.to) ? "nv-link is-active" : "nv-link"}
								>
									{item.text}
								</Link>
							</li>
						)
					)}
					{downloads.length > 0 &&
						withSub(
							{ text: "Downloads" },
							"Downloads",
							downloads.map((file) => (
								<li key={file.id}>
									<a href={file.file} download>
										{file.title}
									</a>
								</li>
							))
						)}
					<li className='nv-item'>
						<Link
							to='/contact'
							className={isActive("/contact") ? "nv-link is-active" : "nv-link"}
						>
							Contact
						</Link>
					</li>
				</ul>
			</div>
		</nav>
	);
};

export default Navbar;
